export const ARTICLE_DETAIL_COMPANY_IMAGE_CLASS_NAME =
  "article-detail-company-image";

export const ARTICLE_MOBILE_UI_CLASS_NAME = "article-detail-mobile-ui-true";
